import script from "./PlayGround.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayGround.vue?vue&type=script&setup=true&lang=js"

import "./PlayGround.vue?vue&type=style&index=0&id=1ffc0920&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffc0920"]])

export default __exports__